module.exports = __webpack_public_path__ + "img/tabler_drag-drop.0c45a89c.svg";